import { render } from "./Logo.vue?vue&type=template&id=0ca9e010&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=0ca9e010&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/哈尔滨超付商务信息咨询服务有限公司/code/lxk_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca9e010"]])

export default __exports__